import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 12,
	viewBox: "0 0 17 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.0942 6C16.0942 4 12.4914 0 8.04712 0C3.60282 0 0 4 0 6C0 8 3.60282 12 8.04712 12C12.4914 12 16.0942 8 16.0942 6ZM12.0511 3.60324L12.0311 3.44287C13.24 4.29836 14.0825 5.34088 14.0825 5.99999C14.0825 7.27856 10.912 9.99998 8.04712 9.99998C5.18222 9.99998 2.01178 7.27856 2.01178 5.99999C2.01178 5.34088 2.85428 4.29836 4.06218 3.44356C4.03672 3.62541 4.02356 3.81117 4.02356 3.99999C4.02356 6.20912 5.82497 7.99998 8.04712 7.99998C10.2693 7.99998 12.0707 6.20912 12.0707 3.99999C12.0707 3.8661 12.0641 3.73375 12.0511 3.60324Z",
		fill: "#1B87E6"
	})]
});
const ForwardRef = forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
